import get from 'lodash/get';

import { INSURANCE_ELIGIBILITY_FIELDS_TYPES } from '../../constants/formFields';

import { getTimeFromDateUTC } from '../../components/PatientHealthboard/utils';

const {
  DO_NOT_HAVE_INSURANCE,
  PRIMARY_SUBSCRIBER,
} = INSURANCE_ELIGIBILITY_FIELDS_TYPES;

export const getRequestPayloadFromFormState = formState => {
  const requestPayloadData = {};

  const payerId = get(formState.healthPlan, 'id');

  requestPayloadData.groupNumber = formState.groupNumber.trim() || null;
  requestPayloadData.memberId = formState.memberId;
  requestPayloadData.payerId = payerId;
  requestPayloadData.primarySubscriber = {};
  requestPayloadData.isPrimarySubscriber = formState[PRIMARY_SUBSCRIBER];

  if (!formState[PRIMARY_SUBSCRIBER]) {
    const state = get(formState.state, 'label') || formState.state;

    requestPayloadData.primarySubscriber.firstName = formState.firstName.trim();
    requestPayloadData.primarySubscriber.lastName = formState.lastName.trim();
    requestPayloadData.primarySubscriber.postalCode = formState.postalCode;
    requestPayloadData.primarySubscriber.address1 = formState.address1.trim();
    requestPayloadData.primarySubscriber.address2 =
      formState.address2.trim() || null;
    requestPayloadData.primarySubscriber.phoneNumber = formState.phoneNumber;
    requestPayloadData.primarySubscriber.gender = formState.gender;
    requestPayloadData.primarySubscriber.insuranceRelationId =
      formState.insuranceRelationId || null;
    requestPayloadData.primarySubscriber.city = formState.city.trim();
    requestPayloadData.primarySubscriber.state = state;
    requestPayloadData.primarySubscriber.dob = getTimeFromDateUTC(
      formState.dob,
      'YYYY-MM-DD',
      false,
    );
  }

  return requestPayloadData;
};



// WEBPACK FOOTER //
// ./src/utils/manage-insurances/get-request-payload-from-form-state.js